import { render, staticRenderFns } from "./uploadImage.vue?vue&type=template&id=fb742778&scoped=true&"
import script from "./uploadImage.vue?vue&type=script&lang=ts&"
export * from "./uploadImage.vue?vue&type=script&lang=ts&"
import style0 from "./uploadImage.vue?vue&type=style&index=0&id=fb742778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb742778",
  null
  
)

export default component.exports